import StatusBadge from "@/components/ui/badge"
import { ColumnDef } from "@tanstack/react-table"

export type Category = {
  id: number
  name: string
  description: string
  image: string
  status: string
  created_at: string
  updated_at: string
}

export const columns: ColumnDef<Category>[] = [
  {
    header: "Name",
    accessorKey: "name",
  },
  // {
  //   header: "Description",
  //   accessorKey: "description",
  // },
  // {
  //   header: "Image",
  //   accessorKey: "image",
  // },
  {
    header: "Status",
    cell: ({ row }) => <StatusBadge name={row.original.status} />,
  },
]
